import moment from 'moment';
import { DOCUMENT_PANEL, SEARCHABLE_TABLE, STATUS_MONITORING } from '../../containers/Dashboard/StatusMonitoring/TranslationValues';
import { JOBQueueModal, PrintingCenter, PrintingModal, PrintingQueue } from '../complexDocumentConstants';
import { removeInvisibleCharacters } from '../helper';
import { EMAIL_DASHBOARD } from '../../containers/Dashboard/TranslationValues';

const JOBMANAGER = 'JOBMANAGER';
const APPROVER_L1 = 'JOBAPPROVERL1';
const APPROVER_L2 = 'JOBAPPROVERL2';
const APPROVER_L3 = 'JOBAPPROVERL3';
const APPROVER_L4 = 'JOBAPPROVERL4';

export const channels = t => {
  const channelArray = [
    {
      id: 1,
      key: t(STATUS_MONITORING.CHART_PRINT_LABEL.key, STATUS_MONITORING.CHART_PRINT_LABEL.value),
      value: 'print',
    },
    {
      id: 2,
      key: t(STATUS_MONITORING.CHART_EMAIL_LABEL.key, STATUS_MONITORING.CHART_EMAIL_LABEL.value),
      value: 'email',
    },
    // {
    //   id: 3,
    //   key: t(
    //     STATUS_MONITORING.CHART_MESSAGES_LABEL.key,
    //     STATUS_MONITORING.CHART_MESSAGES_LABEL.value,
    //   ),
    //   value: 'messages',
    // },
    // {
    //   id: 3,
    //   key: t(STATUS_MONITORING.CHART_SMS_LABEL.key, STATUS_MONITORING.CHART_SMS_LABEL.value),
    //   value: 'sms',
    // },
    // {
    //   id: 4,
    //   key: t(STATUS_MONITORING.CHART_VOICE_LABEL.key, STATUS_MONITORING.CHART_VOICE_LABEL.value),
    //   value: 'voice',
    // },
    // {
    //   id: 5,
    //   key: t(STATUS_MONITORING.CHART_WHATSAPP_LABEL.key, STATUS_MONITORING.CHART_WHATSAPP_LABEL.value),
    //   value: 'whatsapp',
    // },
  ];
  return channelArray.map(channel => ({
    ...channel,
    key: removeInvisibleCharacters(channel.key),
  }));
};

export const stageStatus = (t, activeChannel = 'Documents', isStats = true) => {
  const channel = activeChannel.toLowerCase();
  const statusArray = [
    {
      id: 1,
      key:
        channel === 'email'
          ? t(
              EMAIL_DASHBOARD.FUNNEL_SECTION_SENT_LABEL.key,
              EMAIL_DASHBOARD.FUNNEL_SECTION_SENT_LABEL.value,
            )
          : t(DOCUMENT_PANEL.SUCCESS_CHART_LABEL.key, DOCUMENT_PANEL.SUCCESS_CHART_LABEL.value),
      value: channel === 'email' ? 'sent' : 'success',
    },
    // {
    //   id: 2,
    //   key: t(
    //     DOCUMENT_PANEL.INPROGRESS_CHART_LABEL.key,
    //     DOCUMENT_PANEL.INPROGRESS_CHART_LABEL.value,
    //   ),
    //   value: 'inprogress',
    // },
    {
      id: 2,
      key: t(DOCUMENT_PANEL.FAILURE_CHART_LABEL.key, DOCUMENT_PANEL.FAILURE_CHART_LABEL.value),
      value: 'failure',
    },
  ];
  const emailStatus = [
    {
      id: 4,
      key: t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_DELIVERED_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_DELIVERED_LABEL.value,
      ),
      value: 'delivered',
    },
    {
      id: 5,
      key: t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_OPENS_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_OPENS_LABEL.value,
      ),
      value: 'opens',
    },
    {
      id: 6,
      key: t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_CLICKS_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_CLICKS_LABEL.value,
      ),
      value: 'clicks',
    },
  ];
  channel === 'email' && !isStats && statusArray.push(...emailStatus);
  channel === 'email' &&
    statusArray.push({
      id: 3,
      key: t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_BOUNCED_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_BOUNCED_LABEL.value,
      ),
      value: 'bounced',
    });
  return statusArray.map(status => ({
    ...status,
    key: removeInvisibleCharacters(status.key),
  }));
};

export const batchStatus = (t, roles) => [
  {
    id: 1,
    key: t(STATUS_MONITORING.YET_TO_START.key, STATUS_MONITORING.YET_TO_START.value),
    value: 'yet_to_start',
  },
  {
    id: 2,
    key: t(STATUS_MONITORING.IN_PROGRESS.key, STATUS_MONITORING.IN_PROGRESS.value),
    value: 'in_progress',
  },
  {
    id: 3,
    key: t(STATUS_MONITORING.PROCESSING_COMPLETE.key, STATUS_MONITORING.PROCESSING_COMPLETE.value),
    value: 'processing_complete',
  },
  ...(roles.includes(JOBMANAGER) || roles.includes(APPROVER_L1) ? [
    {
      id: 4,
      key: t(STATUS_MONITORING.WAITING_FOR_APPROVAL_LEVEL_1.key, STATUS_MONITORING.WAITING_FOR_APPROVAL_LEVEL_1.value),
      value: 'waiting_for_approval_level_1',
    },
    {
      id: 5,
      key: t(STATUS_MONITORING.REJECT_BY_LEVEL_1.key, STATUS_MONITORING.REJECT_BY_LEVEL_1.value),
      value: 'reject_by_level_1',
    },
  ] : []),
  ...(roles.includes(JOBMANAGER) || roles.includes(APPROVER_L2) ? [
    {
      id: 6,
      key: t(STATUS_MONITORING.WAITING_FOR_APPROVAL_LEVEL_2.key, STATUS_MONITORING.WAITING_FOR_APPROVAL_LEVEL_2.value),
      value: 'waiting_for_approval_level_2',
    },
    {
      id: 7,
      key: t(STATUS_MONITORING.REJECT_BY_LEVEL_2.key, STATUS_MONITORING.REJECT_BY_LEVEL_2.value),
      value: 'reject_by_level_2',
    },
  ] : []),
  ...(roles.includes(JOBMANAGER) || roles.includes(APPROVER_L3) ? [
    {
      id: 8,
      key: t(STATUS_MONITORING.WAITING_FOR_APPROVAL_LEVEL_3.key, STATUS_MONITORING.WAITING_FOR_APPROVAL_LEVEL_3.value),
      value: 'waiting_for_approval_level_3',
    },
    {
      id: 9,
      key: t(STATUS_MONITORING.REJECT_BY_LEVEL_3.key, STATUS_MONITORING.REJECT_BY_LEVEL_3.value),
      value: 'reject_by_level_3',
    },
  ] : []),
  ...(roles.includes(JOBMANAGER) || roles.includes(APPROVER_L4) ? [
    {
      id: 10,
      key: t(STATUS_MONITORING.WAITING_FOR_APPROVAL_LEVEL_4.key, STATUS_MONITORING.WAITING_FOR_APPROVAL_LEVEL_4.value),
      value: 'waiting_for_approval_level_4',
    },
    {
      id: 11,
      key: t(STATUS_MONITORING.REJECT_BY_LEVEL_4.key, STATUS_MONITORING.REJECT_BY_LEVEL_4.value),
      value: 'reject_by_level_4',
    },
  ] : []),
  ...(roles.includes(JOBMANAGER) ? [
    {
      id: 12,
      key: t(STATUS_MONITORING.NO_APPROVER_FOUND_FILTER.key, STATUS_MONITORING.NO_APPROVER_FOUND_FILTER.value),
      value: 'no_approver_found',
    },
    {
      id: 13,
      key: t(STATUS_MONITORING.READY_TO_PRINT_FILTER.key, STATUS_MONITORING.READY_TO_PRINT_FILTER.value),
      value: 'ready_to_print',
    },
    {
      id: 14,
      key: t(STATUS_MONITORING.PRINT_INITIATED_FILTER.key, STATUS_MONITORING.PRINT_INITIATED_FILTER.value),
      value: 'sent_for_printing',
    },
    {
      id: 15,
      key: t(STATUS_MONITORING.PRINTING_COMPLETE.key, STATUS_MONITORING.PRINTING_COMPLETE.value),
      value: 'printing_complete',
    },
  ] : []),
];

export const getJobStatus = (status, roles) => {
  const statusRoleMap = {
    waiting_for_approval_level_1: APPROVER_L1,
    waiting_for_approval_level_2: APPROVER_L2,
    waiting_for_approval_level_3: APPROVER_L3,
    waiting_for_approval_level_4: APPROVER_L4,
  };

  return statusRoleMap[status] ? roles.includes(statusRoleMap[status]) : false;
};

export const batchInitiation = t => [
  {
    id: 1,
    key: 'DRAFT_UPLOAD',
    value: t(STATUS_MONITORING.DRAFT_UPLOAD_FILTER.key, STATUS_MONITORING.DRAFT_UPLOAD_FILTER.value),
  },
  { 
    id: 2,
    key: 'LIVE_UPLOAD',
    value: t(STATUS_MONITORING.LIVE_UPLOAD_FILTER.key, STATUS_MONITORING.LIVE_UPLOAD_FILTER.value),
  },
  // {
  //   id: 3,
  //   key: 'SANDBOX_API',
  //   value: t(STATUS_MONITORING.SANDBOX_API_FILTER.key, STATUS_MONITORING.SANDBOX_API_FILTER.value),
  // },
  {
    id: 4,
    key: 'LIVE_API',
    value: t(STATUS_MONITORING.LIVE_API_FILTER.key, STATUS_MONITORING.LIVE_API_FILTER.value),
  }
];

export const statusTextColor = [
  'sent_for_printing',
  'waiting_for_approval_level_1',
  'waiting_for_approval_level_2',
  'waiting_for_approval_level_3',
  'waiting_for_approval_level_4',
  'reject_by_level_1',
  'reject_by_level_2',
  'reject_by_level_3',
  'reject_by_level_4',
  'no_approver_found',
];

export const batchAuditData = (statusInfo, users) => {
  const data = [];
  for (let level = 1; level <= 4; level++) {
      data.push({
        level,
        status: null,
        on: null,
        by: null,
      });
  }
  statusInfo.forEach(currentStatus => {
    const level = Number(currentStatus.status.slice(-1));
    const latestStatus = {
      on: moment(currentStatus.createdOn).format('Do MMM YYYY, LT'),
      by: users.find(user => user.id === currentStatus.createdBy)?.displayName,
      level: level,
      status: ''
    };
    if (currentStatus.status?.startsWith('waiting_for_approval')) {
      latestStatus.by = null;
      latestStatus.on = null;
      latestStatus.status = 'Waiting for approval';
      replaceInData(latestStatus, level);
    } else if (currentStatus.status?.startsWith('approved')) {
      latestStatus.status = 'Approved';
      replaceInData(latestStatus, level);
    } else if (currentStatus.status?.startsWith('reject')) {
      latestStatus.status = 'Rejected';
      latestStatus.rejectionReason = currentStatus?.statusMessage;
      latestStatus.email = currentStatus?.email?.split(',') || [];
      replaceInData(latestStatus, level);
    }
  });
  function replaceInData (latestStatus, level) {
    const index = data.findIndex(item => item.level === level);
    if (index !== -1) {
        data[index] = latestStatus;
    }
  }
  data.sort((a, b) => a.level - b.level);
  return data;
};
export const displayDefaultColumns = (t, contentType, activeChannel) => {
  let cols = [
    t(SEARCHABLE_TABLE.UNIQ_ID.key, SEARCHABLE_TABLE.UNIQ_ID.value),
    t(SEARCHABLE_TABLE.UNIQ_NAME.key, SEARCHABLE_TABLE.UNIQ_NAME.value),
    t(SEARCHABLE_TABLE.CHANNEL.key, SEARCHABLE_TABLE.CHANNEL.value),
    t(SEARCHABLE_TABLE.PAYLOAD.key, SEARCHABLE_TABLE.PAYLOAD.value),
  ];

  if (contentType !== JOBQueueModal) {
    cols.splice(3, 0, t(SEARCHABLE_TABLE.STATUS.key, SEARCHABLE_TABLE.STATUS.value));
    if([PrintingQueue, PrintingCenter].includes(contentType)){
      cols.splice(3, 0, t(SEARCHABLE_TABLE.PRINT_STATUS.key, SEARCHABLE_TABLE.PRINT_STATUS.value));
    }
    if (activeChannel === 'Documents') {
      cols.push(t(SEARCHABLE_TABLE.GENERATE_PDF.key, SEARCHABLE_TABLE.GENERATE_PDF.value));
    }
  }
  return cols.map(key => removeInvisibleCharacters(key));
};

export const defaultExtraColumns = (t, contentType, activeChannel, failureRecord) => {
  const baseColumns = [
    'NUMBER_OF_PAGES',
    'TIME_OF_CREATION',
    'FAILURE_REASON',
    'PAYLOAD',
  ];

  let columns = [...baseColumns];

  const isPrintingType = [PrintingModal, PrintingQueue, PrintingCenter].includes(contentType);

  if (contentType !== JOBQueueModal && activeChannel === 'Documents') {
    columns.push('GENERATE_PDF');
  }

  if (!failureRecord && isPrintingType) {
    columns = columns.filter(col => col !== 'FAILURE_REASON');
  }

  if (contentType === JOBQueueModal) {
    columns = columns.filter(col => !['NUMBER_OF_PAGES', 'FAILURE_REASON'].includes(col));
  }

  return columns.map(
    key => removeInvisibleCharacters(t(SEARCHABLE_TABLE[key].key, SEARCHABLE_TABLE[key].value))
  );
};

export const metaSearchKeyMappings = t => {
  const keyObj = {
    channel: t(SEARCHABLE_TABLE.CHANNEL.key, SEARCHABLE_TABLE.CHANNEL.value),
    language: t(SEARCHABLE_TABLE.LANGUAGE.key, SEARCHABLE_TABLE.LANGUAGE.value),
    status: t(SEARCHABLE_TABLE.STATUS.key, SEARCHABLE_TABLE.STATUS.value),
    uniq_name: t(SEARCHABLE_TABLE.UNIQ_NAME.key, SEARCHABLE_TABLE.UNIQ_NAME.value),
    uniq_id: t(SEARCHABLE_TABLE.UNIQ_ID.key, SEARCHABLE_TABLE.UNIQ_ID.value),
  };
  Object.keys(keyObj).forEach(
    key => (keyObj[key] = removeInvisibleCharacters(keyObj[key])),
  );
  return keyObj;
};

export const tableColumnTitle = t => {
  const titleObj = {
    uniq_id: t(SEARCHABLE_TABLE.UNIQ_ID.key, SEARCHABLE_TABLE.UNIQ_ID.value),
    uniq_name: t(SEARCHABLE_TABLE.UNIQ_NAME.key, SEARCHABLE_TABLE.UNIQ_NAME.value),
    pending_status:"Pending_status",
    channel: t(SEARCHABLE_TABLE.CHANNEL.key, SEARCHABLE_TABLE.CHANNEL.value),
    status: t(SEARCHABLE_TABLE.STATUS.key, SEARCHABLE_TABLE.STATUS.value),
    printStatus: t(SEARCHABLE_TABLE.PRINT_STATUS.key, SEARCHABLE_TABLE.PRINT_STATUS.value),
    no_of_pages: t(SEARCHABLE_TABLE.NUMBER_OF_PAGES.key, SEARCHABLE_TABLE.NUMBER_OF_PAGES.value),
    language: t(SEARCHABLE_TABLE.LANGUAGE.key, SEARCHABLE_TABLE.LANGUAGE.value),
    created_on: t(SEARCHABLE_TABLE.TIME_OF_CREATION.key, SEARCHABLE_TABLE.TIME_OF_CREATION.value),
    failure_reason: t(SEARCHABLE_TABLE.FAILURE_REASON.key, SEARCHABLE_TABLE.FAILURE_REASON.value),
    Payload: t(SEARCHABLE_TABLE.PAYLOAD.key, SEARCHABLE_TABLE.PAYLOAD.value),
    GeneratedPDF: t(SEARCHABLE_TABLE.GENERATE_PDF.key, SEARCHABLE_TABLE.GENERATE_PDF.value),
  };
  Object.keys(titleObj).forEach(
    key => (titleObj[key] = removeInvisibleCharacters(titleObj[key])),
  );
  return titleObj;
};

export const emailFunnelChartLabels = t => {
  const labelsObj = {
    sent: t(
      EMAIL_DASHBOARD.FUNNEL_SECTION_SENT_LABEL.key,
      EMAIL_DASHBOARD.FUNNEL_SECTION_SENT_LABEL.value,
    ),
    delivered: t(
      EMAIL_DASHBOARD.FUNNEL_SECTION_DELIVERED_LABEL.key,
      EMAIL_DASHBOARD.FUNNEL_SECTION_DELIVERED_LABEL.value,
    ),
    opened: t(
      EMAIL_DASHBOARD.FUNNEL_SECTION_OPENS_LABEL.key,
      EMAIL_DASHBOARD.FUNNEL_SECTION_OPENS_LABEL.value,
    ),
    clicked: t(
      EMAIL_DASHBOARD.FUNNEL_SECTION_CLICKS_LABEL.key,
      EMAIL_DASHBOARD.FUNNEL_SECTION_CLICKS_LABEL.value,
    ),
  };
  Object.keys(labelsObj).forEach(
    key => (labelsObj[key] = removeInvisibleCharacters(labelsObj[key])),
  );
  return labelsObj;
};

export const printStatusLabelMapping ={
  0: 'yet_to_print',
  1: 'print_in_queue',
  2: 'print_completed'
}

export const afterApprovedStatus = [
  'ready_to_print',
  'sent_for_printing',
  'printing_complete'
]